export enum PageTypes {
  FORM = 'FORM',
  LIST = 'LIST',
  AOPBooking = 'AOPBooking',
  PrintBooking = 'PrintBooking',
  WashBooking = 'WashBooking',
  EmbroideryBooking = 'EmbroideryBooking',
  FabricBooking = 'FabricBooking',
}
